import { render, staticRenderFns } from "./BtnSmallIconAccept.vue?vue&type=template&id=04725166"
import script from "./BtnSmallIconAccept.vue?vue&type=script&lang=js"
export * from "./BtnSmallIconAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports